const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('form-section/block', {
  title: 'Formulário de Contato',
  description: 'Bloco de formulário de contato',
  icon: 'feedback',
  category: 'design',
  attributes,

  getEditWrapperProps() {
    return {
      'data-align': 'full',
    };
  },

  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
